import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import styles from './Container.module.scss'

export default function Container({ children, className }: props) {
  return (
    <div className={classNames('Container', styles.this, className)}>
      {children}
    </div>
  )
}

Container.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/Container/Container.js